/**
 * Environment configuration for server URLs
 */

export interface EnvironmentConfig {
  serverUrl: string;
  isDevelopment: boolean;
}

const getEnvironmentConfig = (): EnvironmentConfig => {
  // Check if we're in development mode
  const isDevelopment = process.env.NODE_ENV === 'development' || 
                       window.location.hostname === 'localhost' ||
                       window.location.hostname === '127.0.0.1';

  // Use localhost for development, production URL for deployed app
  const serverUrl = isDevelopment 
    ? 'http://localhost:8787'
    : 'https://object-property-lww-worker.bret-e4c.workers.dev';

  return {
    serverUrl,
    isDevelopment
  };
};

export const config = getEnvironmentConfig();

// Export individual values for convenience
export const { serverUrl, isDevelopment } = config;
